// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { connectCaredove, login, signup } from '../../actions/caredove-login';
import websocketService from '../../services/websocket-service';
import CaredoveDot from '../../assets/images/caredove-dot.svg';
import PartnerLogin from '../partner-login-template';

type State = {};

type Props = {
  history: History,
  location: any,
  login: (email: string, password: string) => void,
  signup: (email: string, password: string) => void,
  connectCaredove: () => Promise<void>
};


class CaredoveLogin extends Component<Props, State> {
  props: Props;

  connectToCaredove = async () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const token = urlParams.get('referraltoken');
    const socket = await websocketService.connect();
    socket.on('connect', () => {
      return this.props.connectCaredove(token, socket);
    });
  }

  render() {
    const { history } = this.props;
    const urlParams = new URLSearchParams(this.props.location.search);
    const token = urlParams.get('referraltoken');
    if (!token) {
      history.push('/404');
    }
    return (
      <PartnerLogin
        {...this.props}
        partnerInfo={{
          shortName: 'Caredove',
          longName: 'Caredove Inc.',
          website: 'www.caredove.com',
          exchangeImage: CaredoveDot
        }}
        connectPartner={this.connectToCaredove}
        login={this.props.login}
        signup={this.props.signup}
        canDisconnect={false}
        // eslint-disable-next-line i18next/no-literal-string
        exchangeType={'incoming'}
      />);
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  connectCaredove,
  login,
  signup
})(CaredoveLogin);



// WEBPACK FOOTER //
// ./src/components/pages/caredove-login.js